import { trackLink } from "../../../../../../services/analytics";
import getSingleItemProductString from "../getSingleItemProductString";
import { SHOW_FULFILMENT_INFO } from "../constants";
import {
  ADOBE_PRODUCTS_KEY,
  ADOBE_SAVED_ITEMS_SHOW_FULFILMENT_INFO_EVENT_KEY
} from "../../../../../../services/analytics/constants";

export const showFulfilmentInfo = (
  state,
  { payload: { productId, variantId, source, seller } }
) => {
  const newState = {
    ...state,
    trackLink: {
      products: getSingleItemProductString({
        productId,
        variantId,
        source,
        seller
      }),
      savedItemAction: SHOW_FULFILMENT_INFO,
      events: [ADOBE_SAVED_ITEMS_SHOW_FULFILMENT_INFO_EVENT_KEY],
      vars: [ADOBE_PRODUCTS_KEY]
    }
  };

  trackLink({ state: newState });

  return newState;
};
